export default __webpack_public_path__ + "static/media/provider-logo-placeholder.f2220ab9.png";